import styled, { css } from "styled-components";

export const ClassInput = styled.div`
  display: flex;
  padding: 10px;
  /* justify-items: center; */
  align-items: center;
`;

export const InputRadio = styled.input`
  width: 17.5px;
  height: 17.5px;
  padding: 4.6px 4.8px 4.9px 4.7px;
  background-color: #747576;
`;

export const Input = styled.input`
  ${({ theme }) => css`
    width: 250px;
    height: 17.5px;
    padding: 2px 2px 2px 2px;
    border: none;
    font-family: Roboto;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    font-size: 1.7rem;
    border-bottom: ${`1px solid ${theme.colors.lineBlue}`};
  `}
`;

export const LabelInput = styled.label`
  margin: 3px 40px 2px 6px;
  opacity: 0.9;
  font-family: Roboto;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  font-size: 1.7rem;
  line-height: 1.21;
  color: #747576;
  width: 17.5px;
  height: 17.5px;
`;

export const PopupBackground = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: rgba(36, 33, 33, 0.863);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
`;

export const PopupContainer = styled.div`
  width: 500px;
  height: auto;
  border-radius: 12px;
  background-color: white;
  display: flex;
  flex-direction: column;
  padding: 25px;
`;

export const TitleCloseBtn = styled.div`
  display: flex;
  justify-content: flex-end;

  button {
    background-color: transparent;
    border: none;
    font-size: 25px;
    cursor: pointer;
  }
`;

export const BodyTitle = styled.div`
  flex: 50%;
  margin-top: 1px;
  display: flex;

  align-items: center;
  font-size: 1.7rem;
  text-align: center;

  p {
    color: #747576;
    font-weight: 500;
  }
`;

export const Label = styled.div`
  font-weight: 500;
  font-size: 1.5rem;
  font-family: Roboto !important;
  text-align: left;
  margin: 30px 0 5px;
  display: flex;
  justify-content: left;

  label {
    border-bottom: 2px solid #00a2e0;
    color: #414244;
    width: 70%;
  }
`;

export const Footer = styled.div`
  flex: 20%;
  margin: 30px 0 30px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
